import type { PlatformsContent, SearchContent } from "../types";

export const platforms: PlatformsContent = {
  meta: {
    title: "MetaTrader 5 Prop Firm Platform | Flex Fund",
    description:
      "Live MetaTrader 5 with raw spreads, tier-1 liquidity, and 12 ms median fills — the platform a serious prop trader expects, on a funded account.",
  },
  hero: {
    builtOn: "Built on ",
    product: "MetaTrader 5",
    tail: ".",
    line2: "Built for speed.",
    lede: "Live MT5, raw spreads, tier-1 liquidity. 12 ms median fills. Same platform, same data your prop desk uses.",
    ctaSecondary: "See instruments",
  },
  stats: {
    latency: "Median fill latency",
    spread: "Avg pip spread, EUR/USD",
    uptime: "Uptime · 90 days",
    liquidity: "Prime liquidity",
  },
  why: {
    titleLead: "The platform ",
    titleHighlight: "professional traders",
    titleTail: " rely on.",
  },
  features: {
    algoTrading: {
      title: "Algo trading",
      desc: "Run Expert Advisors and custom indicators. MQL5 and Python bridges supported.",
    },
    depthOfMarket: {
      title: "Depth of market",
      desc: "Real DOM with full visible book. Plus Time & Sales feed on every symbol.",
    },
    oneClick: {
      title: "One-click trading",
      desc: "Execute from chart, DOM, or watchlist. Hotkeys + drag-to-modify.",
    },
    mobileDesktop: {
      title: "Mobile + desktop",
      desc: "Same account on Windows, macOS, iOS, Android. State syncs in real time.",
    },
    strategyTester: {
      title: "Strategy tester",
      desc: "Backtest with tick-level data spanning 10+ years.",
    },
    multiAccount: {
      title: "Multi-account",
      desc: "Run up to 5 funded accounts side-by-side from one terminal.",
    },
  },
  faq: {
    titleLead: "Execution & platform ",
    titleHighlight: "questions",
    titleTail: ".",
    sub: "Browse the full library on the Flex Fund knowledge base. Deeper answers, richer detail.",
    browseAll: "Browse all FAQs",
    items: {
      whichPlatforms: { q: "Which trading platforms does Flex Fund offer?", category: "PLATFORM" },
      liquidityExecution: { q: "Who provides liquidity and execution?", category: "EXECUTION" },
      leverage: { q: "What leverage is provided?", category: "RULES" },
      easBots: { q: "Can I use Expert Advisors (EAs) or bots?", category: "PLATFORM" },
    },
  },
};

export const search: SearchContent = {
  meta: {
    title: "Search — Flex Fund",
    description: "Search Flex Fund — prop firm, MetaTrader 5 platform, FAQ, and more.",
  },
  heading: "Search Flex Fund",
  redirecting: "Redirecting to Flex Fund search results…",
};
